(function () {
    'use strict';

    const languages = {
        id: {
            code: 'ID',
            flag: '🇮🇩'
        },

        en: {
            code: 'EN',
            flag: '🇬🇧'
        },

        zh: {
            code: 'ZH',
            flag: '🇨🇳'
        },

        ar: {
            code: 'AR',
            flag: '🇸🇦'
        }
    };


    /*
     * Tentukan bahasa berdasarkan URL.
     *
     * /artikel/       = ID
     * /en/artikel/    = EN
     * /zh/artikel/    = ZH
     * /ar/artikel/    = AR
     */

    function getCurrentLanguage() {
        const path = window.location.pathname;

        const match = path.match(
            /^\/(en|zh|ar)(?=\/|$)/i
        );

        if (match) {
            return match[1].toLowerCase();
        }

        return 'id';
    }


    /*
     * Hapus prefix bahasa dari URL.
     *
     * /en/artikel-a/ → /artikel-a/
     * /zh/artikel-a/ → /artikel-a/
     * /ar/artikel-a/ → /artikel-a/
     */

    function getBasePath() {
        let path = window.location.pathname;

        path = path.replace(
            /^\/(en|zh|ar)(?=\/|$)/i,
            ''
        );

        if (!path) {
            path = '/';
        }

        if (!path.startsWith('/')) {
            path = '/' + path;
        }

        return path;
    }


    /*
     * Buat URL bahasa tujuan.
     */

    function buildLanguageUrl(language) {
        const basePath = getBasePath();

        let target;

        if (language === 'id') {

            target = basePath;

        } else {

            target =
                '/' +
                language +
                (basePath === '/' ? '/' : basePath);
        }

        return (
            target +
            window.location.search +
            window.location.hash
        );
    }


    const currentLanguage = getCurrentLanguage();


    document
        .querySelectorAll('[data-language-switcher]')
        .forEach(function (switcher) {

            const button =
                switcher.querySelector(
                    '[data-language-button]'
                );

            const currentFlag =
                switcher.querySelector(
                    '[data-current-language-flag]'
                );

            const currentCode =
                switcher.querySelector(
                    '[data-current-language-code]'
                );


            /* Current language */

            if (currentFlag) {
                currentFlag.textContent =
                    languages[currentLanguage].flag;
            }

            if (currentCode) {
                currentCode.textContent =
                    languages[currentLanguage].code;
            }


            /*
             * Generate setiap URL.
             */

            switcher
                .querySelectorAll('[data-language-link]')
                .forEach(function (link) {

                    const language =
                        link.dataset.lang;

                    link.href =
                        buildLanguageUrl(language);

                    if (language === currentLanguage) {

                        link.classList.add('is-active');

                        link.setAttribute(
                            'aria-current',
                            'page'
                        );
                    }
                });


            /*
             * Open / close
             */

            button.addEventListener(
                'click',
                function (event) {

                    event.stopPropagation();

                    const willOpen =
                        !switcher.classList.contains(
                            'is-open'
                        );


                    /*
                     * Tutup dropdown lain,
                     * karena terdapat versi desktop + mobile.
                     */

                    document
                        .querySelectorAll(
                            '[data-language-switcher]'
                        )
                        .forEach(function (item) {

                            item.classList.remove(
                                'is-open'
                            );

                            const itemButton =
                                item.querySelector(
                                    '[data-language-button]'
                                );

                            if (itemButton) {
                                itemButton.setAttribute(
                                    'aria-expanded',
                                    'false'
                                );
                            }
                        });


                    if (willOpen) {

                        switcher.classList.add(
                            'is-open'
                        );

                        button.setAttribute(
                            'aria-expanded',
                            'true'
                        );
                    }
                }
            );

        });


    /*
     * Klik di luar dropdown → close
     */

    document.addEventListener(
        'click',
        function () {

            document
                .querySelectorAll(
                    '[data-language-switcher]'
                )
                .forEach(function (switcher) {

                    switcher.classList.remove(
                        'is-open'
                    );

                    const button =
                        switcher.querySelector(
                            '[data-language-button]'
                        );

                    if (button) {

                        button.setAttribute(
                            'aria-expanded',
                            'false'
                        );
                    }
                });
        }
    );


    /*
     * ESC → close
     */

    document.addEventListener(
        'keydown',
        function (event) {

            if (event.key !== 'Escape') {
                return;
            }

            document
                .querySelectorAll(
                    '[data-language-switcher]'
                )
                .forEach(function (switcher) {

                    switcher.classList.remove(
                        'is-open'
                    );

                    const button =
                        switcher.querySelector(
                            '[data-language-button]'
                        );

                    if (button) {

                        button.setAttribute(
                            'aria-expanded',
                            'false'
                        );
                    }
                });
        }
    );

})();